import React, { createRef } from "react";
import { CardOption, BookingPricingCard } from "../../components/";
import { api } from "../../api";
import Loading from "../Loading";
import moment from "moment-timezone";
import { toast, Bounce } from "react-toastify";

class ResumeService extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedService: "",
      serviceOptions: [
        {
          name: "Car Wash",
          isSelected: true,
        },
        {
          name: "Wash & Detail",
          isSelected: false,
        },
      ],
      locationPricing: [],
      loading: true,
      toastMessage: createRef(null),
    };
    this.selectServiceType = this.selectServiceType.bind(this);
    this.displayServiceCapacityModal =
      this.displayServiceCapacityModal.bind(this);
  }

  selectServiceType(id, name, price, time, currentHour) {
    console.log("ResumeService selectServiceType called with:", {
      id,
      name,
      price,
      time,
      currentHour,
    });

    // For resume booking, we need more complex pricing logic
    const vehicleType = this.props.selectedVehicleType
      .split(" ")[0]
      .toLowerCase();

    // Find the service item from locationPricing
    const serviceItem = this.state.locationPricing.find(
      (item) => item._id === id
    );
    let servicePrice = price;

    if (serviceItem && serviceItem[vehicleType]) {
      const vehiclePricing = serviceItem[vehicleType];
      servicePrice = vehiclePricing.price || vehiclePricing.value;
    }

    this.setState({
      selectedService: id,
    });

    this.setState((prevState) => ({
      serviceOptions: prevState.serviceOptions.map((obj) =>
        obj.name === name
          ? { ...obj, isSelected: true }
          : { ...obj, isSelected: false }
      ),
    }));

    console.log("Calling handleSelectServiceType with:", {
      name,
      id,
      servicePrice,
      currentHour,
    });
    this.props.handleSelectServiceType(
      id,
      name,
      servicePrice,
      time,
      currentHour
    );
  }

  async getLocationPricing(locationId) {
    console.log("ResumeService fetching location pricing for:", locationId);
    const pricing = await api(`location/${locationId}/pricing`, "GET", null);
    if (pricing.status == 200) {
      var resp = pricing.data;
      if (resp.success) {
        console.log("ResumeService location pricing response:", resp.pricing);
        this.setState({
          locationPricing: resp.pricing,
          serviceOptions: resp.pricing,
        });
      } else {
        console.error(
          "ResumeService failed to get location pricing:",
          resp.message
        );
        alert(resp.message);
      }
    } else {
      console.error("ResumeService API call failed:", pricing);
    }
    this.setState({
      loading: false,
    });
  }

  componentDidMount() {
    console.log("ResumeService componentDidMount");
    if (typeof this.props.selectedServiceId == "object") {
      if (this.props.selectedServiceId.length > 0) {
        this.setState({
          selectedService: this.props.selectedServiceId[0].id,
        });
      }
    } else {
      if (this.props.selectedServiceId !== "") {
        this.setState({
          selectedService: this.props.selectedServiceId,
        });
      }
    }

    this.getLocationPricing(this.props.selectedLocation._id);
  }

  componentDidUpdate(prevProps) {
    // Re-fetch pricing when location changes
    if (
      this.props.selectedLocation !== prevProps.selectedLocation &&
      this.props.selectedLocation
    ) {
      this.getLocationPricing(this.props.selectedLocation._id);
    }
  }

  displayServiceCapacityModal() {
    const error = toast.error(
      "Sorry, you are unable to select this service due to the booking time you have selected. Please select another time or service, Thank you.",
      {
        toastId: "serviceSelectErrorToast",
        position: "bottom-center",
        style: {
          bottom: "5vh",
        },
        autoClose: 7000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        transition: Bounce,
      }
    );
    this.setState({
      toastMessage: { current: error },
    });
  }

  render() {
    console.log("ResumeService rendering with state:", this.state);
    console.log("ResumeService rendering with props:", this.props);

    let parentThis = this;
    const pricingOrder = [
      "Hand Polish",
      "Interior Detail",
      "Full Detail",
      "Paint Protection",
      "Ceramic Coating",
      "Express Wash",
      "Economy Wash",
      "Premium Wash",
      "Super Wash",
      "Mini Detail",
    ];

    let pricingOptions = this.state.locationPricing.sort((a, b) => {
      // Handle different data structures safely
      const aServiceName = a.service?.[0]?.name || a.name || "";
      const bServiceName = b.service?.[0]?.name || b.name || "";

      const aIndex = pricingOrder.findIndex(
        (service) => service.toLowerCase() === aServiceName.toLowerCase()
      );
      const bIndex = pricingOrder.findIndex(
        (service) => service.toLowerCase() === bServiceName.toLowerCase()
      );
      return aIndex - bIndex;
    });

    return (
      <div id="serviceTypeSelection">
        <div
          className="serviceTypeSection"
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: "20px",
            gridAutoRows: "min-content",
          }}
        >
          {this.state.loading ? (
            <div className="text-center" style={{ gridColumn: "1 / -1" }}>
              <Loading />
            </div>
          ) : (
            pricingOptions.map(function (item, i) {
              console.log(`ResumeService pricing item ${i}:`, item);

              var selectedType = parentThis.props.selectedVehicleType;
              const activeOffer = parentThis.props.offerDetails;
              let offerDiscount = null;

              console.log("ResumeService activeOffer:", activeOffer);
              console.log("ResumeService item:", item);

              if (activeOffer) {
                if (
                  !activeOffer.services ||
                  activeOffer.services.length === 0
                ) {
                  // No specific service restriction, apply offer to all
                  offerDiscount = {
                    value: activeOffer.value,
                    type: activeOffer.type,
                    code: activeOffer.code,
                  };
                } else {
                  // Get the service name from the item
                  const itemServiceName =
                    item.service?.[0]?.name || item.name || "";

                  // Check if this service matches any in the offer
                  const matchedService = activeOffer.services.find(
                    (service) =>
                      service.name === itemServiceName ||
                      service._id === item._id
                  );

                  console.log("ResumeService service matching:", {
                    itemServiceName,
                    itemId: item._id,
                    offerServices: activeOffer.services,
                    matchedService,
                  });

                  if (matchedService) {
                    offerDiscount = {
                      value: activeOffer.value,
                      type: activeOffer.type,
                      code: activeOffer.code,
                    };
                  }
                }
              }

              console.log("ResumeService final offerDiscount:", offerDiscount);

              return (
                <BookingPricingCard
                  key={i}
                  item={item}
                  selectedType={selectedType}
                  dateRange={parentThis.props.dateRange}
                  selectServiceType={(id, name, price, time, currentHour) => {
                    var canSelect = false;
                    if (
                      parentThis.props.serviceSpecificCapacities !==
                        undefined &&
                      parentThis.props.serviceSpecificCapacities !== false
                    ) {
                      let serviceId = id;
                      if (
                        parentThis.props.serviceSpecificCapacities[serviceId]
                      ) {
                        canSelect = false;
                        var selectedTime = moment(
                          parentThis.props.dateRange.split(" - ")[0],
                          "MMM Do h:mmA"
                        ).format("HH:mm");
                        var availability =
                          parentThis.props.serviceSpecificCapacities[serviceId];
                        for (
                          let index = 0;
                          index < availability.length;
                          index++
                        ) {
                          const element = availability[index];
                          if (element.timeStart == selectedTime) {
                            canSelect = true;
                            break;
                          }
                        }
                      } else {
                        canSelect = true;
                      }
                    } else {
                      canSelect = true;
                    }

                    if (canSelect) {
                      console.log("ResumeService selectedItem (id):", id);
                      console.log("ResumeService currentHour:", currentHour);

                      toast.dismiss(parentThis.state.toastMessage.current);

                      parentThis.selectServiceType(
                        id,
                        name,
                        price,
                        time,
                        currentHour
                      );
                    } else {
                      parentThis.displayServiceCapacityModal();
                    }
                  }}
                  selectedService={parentThis.state.selectedService}
                  bundleSelected={parentThis.props.selectedBundle}
                  selectedLocation={parentThis.props.selectedLocation}
                  offerDiscount={offerDiscount}
                />
              );
            })
          )}
        </div>
      </div>
    );
  }
}

export default ResumeService;
